<form [formGroup]="MatriculaForm" novalidate>
    <div class="container  border border-success rounded mt-2">
        <div class="alert " role="alert" *ngIf="cargandoDatos" class="alert-success">
            <h4 class="alert-heading">Cargando datos</h4>
            <hr>
            <p class="mb-0">Se está cargando la información.</p>
            <app-progress *ngIf="cargandoDatos"></app-progress>
        </div>
        <div class="card border border-success mt-3" *ngIf="!cargandoDatos">
            <h5 class="card-header">Matricula
                <a class="d-flex justify-content-md-end" data-toggle="collapse" href="#DD" role="button"
                    aria-expanded="true" aria-controls="DD"></a>
            </h5>
            <div class="collapse show" id="DD">
                <div class="card-body">
                    <div class="alert " role="alert" class="alert-success">
                        <h4 class="alert-heading">Te damos la Bienvenida a Santo Tomás, ya estas matriculado</h4>
                        <hr>
                        <p class="mb-0">Bienvenido Tomasin@, ya estás matriculado en la Universidad Santo Tomás. En tú
                            correo </p>
                        <p class="mb-0">recibirás el contrato firmado, la cuenta de e-mail y clave para ingresar a tu
                            intranet </p>
                        <p class="mb-0"> <a href="https://miintranet.santotomas.cl/"> (
                                https://miintranet.santotomas.cl/ ).</a> </p>
                    </div>

                    <div class="form-group row">
                        <div class="col-sm-6">

                            <label>RUT</label>
                            <input type="text" class="form-control form-control-sm" formControlName="RUT">

                        </div>
                        <div class="col-sm-6">
                            <label>Folio</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Folio">

                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6">

                            <label>Nombre Alumno</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Nombre">

                        </div>
                        <div class="col-sm-6">
                            <label>Apellido Alumno</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Apellido">

                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6">

                            <label>Institución</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Institucion">

                        </div>
                        <div class="col-sm-6">
                            <label>Sede</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Sede">

                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6">

                            <label>Carrera</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Carrera">

                        </div>
                        <div class="col-sm-6">
                            <label>Jornada</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Jornada">

                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <label>Monto pagado al contado</label>
                            <input type="text" class="form-control form-control-sm" formControlName="Montopagado">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <label></label>
                            <table class="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Nro. de cuotas</th>
                                        <th scope="col">Monto de cuotas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Matrícula</th>
                                        <td>{{nroCuotaMatri}}</td>
                                        <td>{{montoCuotaMatri | currency:'CLP':'symbol'}}</td>
                                    <tr>
                                    <tr>
                                        <th scope="row">Arancel</th>
                                        <td>{{nroCuotaArancel}}</td>
                                        <td>{{montoCuotaArancel | currency:'CLP':'symbol'}}</td>
                                    <tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="row">
                        <div class="m-auto">
                            <a (click)='Descargar()' class="mt-1" style="cursor:pointer; color: #114B43;">
                                Descargar comprobante de matrícula</a>
                            <div class="text-center d-flex justify-content-center mt-3">
                                <button type="button" class="btn btn-info mr-2" (click)="goToDocument()">
                                    Verificar documentos
                                </button>
                                <a href="/" class="btn btn-danger">Fin del Proceso</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</form>